export default "__VITE_ASSET__241fb74a__$_?nuxt_component=async&nuxt_component_name=Svgo5min__"